import { render, staticRenderFns } from "./DeptEditPageSender.vue?vue&type=template&id=1e09b644&scoped=true&"
import script from "./DeptEditPageSender.vue?vue&type=script&lang=js&"
export * from "./DeptEditPageSender.vue?vue&type=script&lang=js&"
import style0 from "./DeptEditPageSender.vue?vue&type=style&index=0&id=1e09b644&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e09b644",
  null
  
)

export default component.exports